import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const updateNotFoundMetadata = () => {
  if (typeof document === 'undefined') return;
  document.title = 'Page Not Found — Color Match';

  const setMeta = (name: string, content: string) => {
    let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute('name', name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  setMeta('robots', 'noindex, nofollow');
  setMeta('description', 'The page you are looking for does not exist.');
};

const NotFoundPage: React.FC = () => {
  useEffect(() => {
    updateNotFoundMetadata();
  }, []);

  return (
    <Layout>
      <div className="text-center py-20">
        <h1 className="text-6xl font-bold text-ink-faint mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-ink-secondary mb-4">
          Page Not Found
        </h2>
        <p className="text-ink-muted mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="ui-button-primary"
          >
            Color Explorer
          </Link>
          <Link
            to="/blog"
            className="ui-button-secondary"
          >
            Read the Blog
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
